import { FC, useMemo } from 'react';

import { useTemplateQueryContext } from './TemplateQueryContext';
import { UnselectedMessageMedium } from '../common/types';
import { useMessageTypesByMedium } from '../hooks/useMessageTypesByMedium';
import {
  MessageTypesQueryContext,
  MessageTypesQueryContextState,
} from './MessageTypesQueryContext';

export const MessageTypesQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { medium } = useTemplateQueryContext();

  const queryOptions = useMemo(
    () => ({
      skip: medium === UnselectedMessageMedium.Unselected,
      variables: { messageMedium: medium },
    }),
    [medium],
  );

  const MessageTypes = useMessageTypesByMedium(queryOptions);

  const { errorMessage = '', hasError, isLoading, refetch, results } = MessageTypes;

  const refetchMessageTypes = () => {
    refetch({ messageMedium: medium });
  };

  const context: MessageTypesQueryContextState = {
    errorMessage,
    hasError,
    isLoading,
    refetch: refetchMessageTypes,
    messageTypes: results,
  };

  return (
    <MessageTypesQueryContext.Provider value={context}>
      {children}
    </MessageTypesQueryContext.Provider>
  );
};
